import { render } from "./StagingSettingView.vue?vue&type=template&id=2b8e10b7&scoped=true"
import script from "./StagingSettingView.vue?vue&type=script&lang=js"
export * from "./StagingSettingView.vue?vue&type=script&lang=js"

import "./StagingSettingView.vue?vue&type=style&index=0&id=2b8e10b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8e10b7"]])

export default __exports__